import { formatCompactAmount } from "./format";

// 把 server 端聚合好的金額分桶（rangeStart/rangeEnd/count）補上顯示用標籤。
// 單一桶（所有金額相同）時只顯示一個數字，不顯示區間。
// eslint-disable-next-line import/prefer-default-export
export function labelAmountBuckets(buckets) {
  if (!buckets || buckets.length === 0) {
    return [];
  }

  return buckets.map((bucket) => {
    const rangeStart = Math.round(bucket.rangeStart);
    const rangeEnd = Math.round(bucket.rangeEnd);
    return {
      ...bucket,
      rangeStart,
      rangeEnd,
      label:
        rangeStart === rangeEnd
          ? formatCompactAmount(rangeStart)
          : `${formatCompactAmount(rangeStart)}-${formatCompactAmount(rangeEnd)}`,
    };
  });
}
